import StrikethroughToolbarView from "./StrikethroughToolbarView.vue";
import {Strike as StrikethroughExtension} from "@tiptap/extension-strike";

export default class Strikethrough {

    constructor() {
        this.toolbarView = StrikethroughToolbarView;
    }

    static create() {
        return new Strikethrough();
    }

    getExtensions() {
        return [StrikethroughExtension];
    }
}